import { createFileRoute } from "@tanstack/react-router";
import { PortfolioLayout } from "#/features/portfolio/components/portfolio-layout";

export const Route = createFileRoute("/portfolio")({
	ssr: false,
	component: PortfolioLayout,
});
